import * as React from "react";
import PropTypes from "prop-types";

export default function Layout({ header, content, footer }) {
  return (
    <section className="layout__main">
      <div className="layout__header">{header}</div>
      <div className="layout__content">{content}</div>
      {footer && <div>{footer}</div>}
    </section>
  );
}

Layout.propTypes = {
  header: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  footer: PropTypes.node,
};
